import { Container, Grid, Box } from "@mui/material";
import Input from "@/components/ph/Input";
import FormSection from "../../utils/FormSection";

import { useInsuranceValidation } from "../hooks/useInsuranceValidation";

const InsuranceData = () => {
  const motorField = useInsuranceValidation("motor", {
    required: true,
    validate: (value) => {
      if (!/^[A-Z0-9]+$/.test(value)) return "Longitud invalida";
      if (value.length < 6 || value.length > 17) return "Longitud invalida";
      return "";
    },
    transformValue: (v) => v.toUpperCase().slice(0, 17),
  });

  const numSerieField = useInsuranceValidation("numSerie", {
    required: true,
    validate: (value) => {
      if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(value)) return "Longitud invalida";
      return "";
    },
    transformValue: (v) => v.toUpperCase().slice(0, 17),
  });

  const placaField = useInsuranceValidation("placa", {
    required: true,
    validate: (value) => {
      if (!/^[A-Z0-9]{6,7}$/.test(value)) return "Longitud invalida";
      return "";
    },
    transformValue: (v) => v.toUpperCase().slice(0, 7),
  });

  return (
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
      <FormSection title="OTROS DATOS DEL VEHÍCULO">
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 12}}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                  <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                    <Input
                      errorMessage={motorField.getErrorMessage()}
                      label="Motor"
                      name="motor"
                      value={motorField.value}
                      onChange={motorField.onChange}
                      onBlur={motorField.onBlur}
                      required
                      type="text"
                      isInvalid={motorField.isInvalid}
                    />
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                    <Input
                      errorMessage={numSerieField.getErrorMessage()}
                      label="Número de serie"
                      name="numSerie"
                      value={numSerieField.value}
                      onChange={numSerieField.onChange}
                      onBlur={numSerieField.onBlur}
                      required
                      type="text"
                      isInvalid={numSerieField.isInvalid}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                    <Input
                      errorMessage={placaField.getErrorMessage()}
                      label="Placa"
                      name="placa"
                      value={placaField.value}
                      onChange={placaField.onChange}
                      onBlur={placaField.onBlur}
                      required
                      type="text"
                      isInvalid={placaField.isInvalid}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
        </Grid>
      </FormSection>
    </Container>
  );
};

export default InsuranceData;
